export default __webpack_public_path__ + "static/media/368.331b8f8d.jpg";